@reference "~/styles.css";

@layer components {
	.notification {
		@apply rounded-sm;

		&:global(.ant-notification-notice-success) {
			@apply bg-green-100;

			& :global(.ant-notification-notice-icon) {
				@apply text-green-600;
			}
		}

		&:global(.ant-notification-notice-info) {
			@apply bg-(--foundation-blue-100);

			& :global(.ant-notification-notice-icon) {
				@apply text-(--foundation-blue-600);
			}
		}

		&:global(.ant-notification-notice-warning) {
			@apply bg-yellow-100;

			& :global(.ant-notification-notice-icon) {
				@apply text-yellow-600;
			}
		}

		&:global(.ant-notification-notice-error) {
			@apply bg-red-100;

			& :global(.ant-notification-notice-icon) {
				@apply text-red-500;
			}
		}
	}
}
